import React, { FC, PropsWithChildren, useEffect } from "react";
import { Box, Backdrop } from "@mui/material";
import {
  idleView,
  modalContainerStyles,
  modalContentWrapperStyles,
  prioritizedView,
  rootContainerStyles,
  topmostView,
} from "./modal.styles";

interface IModalProps {
  isIdle?: boolean;
  prioritized?: boolean;
  topmost?: boolean;
  disableBodyScroll?: boolean;
}

const Modal: FC<PropsWithChildren<IModalProps>> = ({
  children,
  isIdle,
  prioritized,
  topmost,
  disableBodyScroll,
}) => {
  useEffect(() => {
    if (disableBodyScroll) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [disableBodyScroll]);

  return (
    <Backdrop
      open
      sx={[
        rootContainerStyles,
        !!prioritized && prioritizedView,
        !!topmost && topmostView,
        !!isIdle && idleView,
      ]}
    >
      <Box sx={modalContainerStyles}>
        <Box sx={modalContentWrapperStyles}>{children}</Box>
      </Box>
    </Backdrop>
  );
};

export default Modal;
